import { useState } from 'react'
import { Info } from 'lucide-react'

/**
 * Version Info Component
 * Displays build version and timestamp - helpful for verifying deployments and cache issues
 */
export const VersionInfo = () => {
  const [showDetails, setShowDetails] = useState(false)

  let version: any = { version: '1.0.0', buildTime: 'unknown' }
  try {
    version = require('../version.json')
  } catch (e) {
    // version.json not available in development
  }

  return (
    <div className="fixed bottom-2 right-2 z-50">
      <button
        onClick={() => setShowDetails(!showDetails)}
        className="flex items-center gap-1 px-2 py-1 text-xs text-gray-400 hover:text-gray-600 transition-colors bg-white/50 rounded shadow-sm"
        title="Build Information"
      >
        <Info className="w-3 h-3" />
        v{version.version}
      </button>

      {showDetails && (
        <div className="absolute bottom-full right-0 mb-2 bg-white border border-gray-200 rounded-lg shadow-lg p-3 min-w-[250px]">
          <div className="text-xs space-y-1">
            <div className="font-semibold text-gray-900 mb-2">Build Information</div>
            <div className="flex justify-between">
              <span className="text-gray-600">Version:</span>
              <span className="font-mono text-gray-900">{version.version}</span>
            </div>
            {version.gitCommit && (
              <div className="flex justify-between">
                <span className="text-gray-600">Commit:</span>
                <span className="font-mono text-gray-900">{version.gitCommit}</span>
              </div>
            )}
            {version.buildTime && (
              <>
                <div className="flex justify-between">
                  <span className="text-gray-600">Built:</span>
                  <span className="font-mono text-gray-900">
                    {new Date(version.buildTime).toLocaleDateString()}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Time:</span>
                  <span className="font-mono text-gray-900">
                    {new Date(version.buildTime).toLocaleTimeString()}
                  </span>
                </div>
              </>
            )}
          </div>
          <button
            onClick={() => setShowDetails(false)}
            className="mt-2 w-full text-xs text-gray-500 hover:text-gray-700"
          >
            Close
          </button>
        </div>
      )}
    </div>
  )
}
